import axios from "axios";
import {createUrlParams} from "../utils/urlParams";


export const getGroups = async (groupFilter) => {
    const urlParams = createUrlParams(groupFilter)
    const url = `/api/v1/groups?${urlParams.toString()}`;
    const res = await axios.get(url);
    return res.data;
}

export const createGroup = async (data) => {
    const url = `/api/v1/groups`;
    const res = await axios.post(url, data);
    return res.data;
}

export const deleteGroup = async (id) => {
    const url = `/api/v1/groups/${id}`;
    const res = await axios.delete(url);
    return res.data;
}